import { useMutation } from '@tanstack/react-query';
import { queryClient, QUERY_KEYS } from '@src/query';
import { removeBrandContent } from './api';

export const useMutationRemoveBrandContents = (collectionId?: string) => useMutation({
  mutationFn: (brandContentId: string) => removeBrandContent(brandContentId),
  onSuccess: async () => {
    queryClient.invalidateQueries({ queryKey: QUERY_KEYS.brandContentCollection(collectionId) });
  },
});
